module services {
    export module logistics {
        export class commercialInvoiceItemTrackingService implements interfaces.logistics.ICommercialInvoiceItemTrackingService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            remove(ciiId: number): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "CommercialInvoiceItemTracking/Delete", {
                    ciiId: ciiId
                });
            }
        }
    }
    angular.module("app").service("commercialInvoiceItemTrackingService", services.logistics.commercialInvoiceItemTrackingService);
}